
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsModal',
  components: { DesignContentLayout }
};
